export default "__VITE_ASSET__BiLLc9kr__"